import { TwistedNodesInfo } from '../../based-finance/types';

export const twistedNodes: { [contractName: string]: TwistedNodesInfo } = {
  TwistedNodesShort: {
    rewardToken: "",
    type: "SHORT",
    price: 0,
    lifeSpan: 0,
    roiPeriod: 0,
    nodeName: "TWISTEDNODES"
  },
  TwistedNodesMedium: {
    rewardToken: "",
    type: "MEDIUM",
    price: 0,
    lifeSpan: 0,
    roiPeriod: 0,
    nodeName: "TWISTEDNODESMEDIUM"
  },
  TwistedNodesLong: {
    rewardToken: "",
    type: "LONG",
    price: 0,
    lifeSpan: 0,
    roiPeriod: 0,
    nodeName: "TWISTEDNODESLONG"
  }
};
